import styled from 'styled-components';

const MainContainer = styled.div`
  background: #dedede;
  justify-content: center;
  display: flex;
`;

export default MainContainer;
